"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cheerio_1 = __importDefault(require("cheerio"));

var service_1 = require("./service");

var Facebook =
/*#__PURE__*/
function (_service_1$Service) {
  _inherits(Facebook, _service_1$Service);

  function Facebook() {
    _classCallCheck(this, Facebook);

    return _possibleConstructorReturn(this, _getPrototypeOf(Facebook).apply(this, arguments));
  }

  _createClass(Facebook, null, [{
    key: "getProofUrl",
    value: function getProofUrl(proof) {
      return this.normalizeUrl(proof);
    }
  }, {
    key: "normalizeUrl",
    value: function normalizeUrl(proof) {
      var proofUrl = proof.proof_url.toLowerCase();
      var urlRegex = /(?:http[s]*:\/\/){0,1}(?:[a-zA-Z0-9-]+\.)+facebook\.com/;
      proofUrl = _get(_getPrototypeOf(Facebook), "prefixScheme", this).call(this, proofUrl);

      if (proofUrl.startsWith('https://facebook.com')) {
        var tokens = proofUrl.split('https://facebook.com');
        proofUrl = "https://www.facebook.com".concat(tokens[1]);
        tokens = proofUrl.split('https://www.facebook.com/')[1].split('/posts/');
        var postId = tokens[1];
        proofUrl = "https://www.facebook.com/".concat(proof.identifier, "/posts/").concat(postId);
      } else if (proofUrl.match(urlRegex)) {
        var _tokens = proofUrl.split('facebook.com/')[1].split('/posts/');

        var _postId = _tokens[1];
        proofUrl = "https://www.facebook.com/".concat(proof.identifier, "/posts/").concat(_postId);
      } else {
        throw new Error("Proof url ".concat(proof.proof_url, " is not valid for service ").concat(proof.service));
      }

      return proofUrl;
    }
  }, {
    key: "getProofStatement",
    value: function getProofStatement(searchText) {
      var $ = cheerio_1.default.load(searchText);
      var statement = $('meta[name="description"]').attr('content');
      return statement !== undefined ? statement.trim() : '';
    }
  }]);

  return Facebook;
}(service_1.Service);

exports.Facebook = Facebook;